import React from 'react';
interface SectionHeaderProps {
  eyebrow: string;
  title: string;
  description?: string;
  centered?: boolean;
}
export function SectionHeader({
  eyebrow,
  title,
  description,
  centered = false
}: SectionHeaderProps) {
  return <div className={`mb-12 md:mb-16 ${centered ? 'text-center flex flex-col items-center' : ''}`} data-id="element-141">
      <div className="flex items-center gap-4 mb-4" data-id="element-142">
        <div className="w-8 h-[2px] bg-gold" data-id="element-143" />
        <span className="text-gold font-bold text-xs tracking-widest uppercase" data-id="element-144">
          {eyebrow}
        </span>
      </div>
      <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-6 leading-tight" data-id="element-145">
        {title}
      </h2>
      {description && <p className="text-lg text-slate-400 max-w-3xl leading-relaxed" data-id="element-146">
          {description}
        </p>}
    </div>;
}